// extracted by mini-css-extract-plugin
module.exports = {"cta":"Cta_cta__3USbj","container":"Cta_container__1-e_t","cta-block":"Cta_cta-block__2ISL9","cta-block__content":"Cta_cta-block__content___7p5R"};